import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotComicsGrid from './components/HotComicsGrid';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import ReviewsSection from './components/ReviewsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotComicsGrid />
        <CategoryNav />
        <LatestUpdates />
        <ReviewsSection />
        <CTASection />
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '韩漫漫画网站 - 好看的韩国漫画_韩漫在线免费阅读_韩漫大全',
          description: '韩漫漫画网站汇聚了众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集',
          url: 'https://www.example.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫漫画网站',
            url: 'https://www.example.com',
          },
          about: {
            '@type': 'Thing',
            name: '韩国漫画',
          },
        })}
      </script>
    </>
  );
}